import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    searchbar: {
        backgroundColor: 'whitesmoke',
        opacity: '100%',
        width: '200px',
        borderWidth: '0px',
        borderRadius: '5px',

    },
    adornment: {
        marginRight: '5px',
    },
    notchedOutline: {
        borderWidth: '1px',
        borderColor: 'grey',
        borderRadius: '5px',
        padding: '0px 5px',
        opacity: '10%',
    },
}));
